(function($) {
    function GaEvent($el, category, action, label, value) {
        this.$el = $el;
        this.category = category;
        this.action = action;
        this.label = label;
        this.value = value;

        this.$el.on('click', this._send.bind(this));
    }

    GaEvent.prototype._send = function() {
        mtag('event', this.action, {event_category: this.category, event_label: this.label, value: this.value});
    };

    $.fn.gaEvent = function(category, action, label, value) {
        var $this = $(this);

        if ($this.data('ga-event') == null) {
            $this.data('ga-event', new GaEvent($this, category, action, label, value));
        }
    }
})(jQuery);

